import React from "react";
import "./ScrolldownButton.less";
// @ts-ignore
import NavDownIcon from 'new-images/nav-down.svg';

interface ScrolldownButtonProps {
	onClick: () => void
}


export const ScrolldownButton: React.FC<ScrolldownButtonProps> = ({
	onClick
}) => {
	return (
		<div
			className="scrolldown-button"
			onClick={() => onClick()}
		>
			<div className="scrolldown-button__icon" dangerouslySetInnerHTML={{__html: NavDownIcon}}/>
		</div>
	)
}
